/**
 * BrainSwipe Finished Page
 */
import { useSwipeStore } from '../stores/swipe';
import { shareResult } from '../lib/share';
import { detectPlatform } from '../platform/detect';

export function BrainSwipeFinished() {
  const { session, reset } = useSwipeStore();
  
  const questionsAnswered = session?.questionsAnswered ?? 0;
  const correctAnswers = session?.correctAnswers ?? 0;
  const totalPoints = session?.totalPoints ?? 0;
  const currentStreak = session?.currentStreak ?? 0;
  
  const accuracy = questionsAnswered > 0
    ? Math.round((correctAnswers / questionsAnswered) * 100)
    : 0;
  
  const getPerformance = (acc: number) => {
    if (acc >= 90) return { emoji: '🏆', text: 'Превосходно!', color: 'from-yellow-500 to-amber-500' };
    if (acc >= 70) return { emoji: '🌟', text: 'Отлично!', color: 'from-green-500 to-emerald-500' };
    if (acc >= 50) return { emoji: '👍', text: 'Хорошо!', color: 'from-blue-500 to-cyan-500' };
    return { emoji: '💪', text: 'Продолжай!', color: 'from-purple-500 to-indigo-500' };
  };
  
  const performance = getPerformance(accuracy);
  
  const handlePlayAgain = async () => {
    await reset();
  };
  
  const handleCreateOwn = () => {
    window.location.href = '/?mode=play';
  };
  
  const handleShare = () => {
    const platform = detectPlatform();
    let url: string;
    if (platform === 'vk') {
      url = 'https://vk.com/app52236695#swipe';
    } else if (platform === 'telegram') {
      url = 'https://t.me/qwizmug_bot?start=swipe_brain';
    } else {
      url = 'https://beshek.mugstel.ru/swipe';
    }
    const text = `🧠 Я набрал ${accuracy}% в BrainSwipe!\n⚡ ${totalPoints} очков\n\nСможешь лучше?`;
    shareResult({ text, url });
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-900 via-purple-800 to-indigo-900 text-white flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center p-6">
        <button
          onClick={() => window.location.href = "/swipe"}
          className="self-start px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-lg text-sm text-white transition-all mb-4"
        >
          ← Меню Swipe
        </button>
        <div className="text-6xl mb-4">{performance.emoji}</div>
        <h1 className="text-3xl font-bold mb-2">{performance.text}</h1>
        <p className="text-purple-300 mb-8">Игра завершена</p>
        
        <div className="w-full max-w-sm bg-white/10 backdrop-blur rounded-2xl p-6">
          <div className="grid grid-cols-2 gap-6 mb-6">
            <div className="text-center">
              <div className="text-3xl font-bold">⚡{totalPoints}</div>
              <div className="text-sm text-purple-300">Очков</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold">{accuracy}%</div>
              <div className="text-sm text-purple-300">Точность</div>
            </div>
          </div>
          
          <div className="h-px bg-white/20 mb-6"></div>
          
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-xl font-bold">{questionsAnswered}</div>
              <div className="text-xs text-purple-300">Вопросов</div>
            </div>
            <div>
              <div className="text-xl font-bold text-green-400">{correctAnswers}</div>
              <div className="text-xs text-purple-300">Правильно</div>
            </div>
            <div>
              <div className="text-xl font-bold text-orange-400">🔥{currentStreak}</div>
              <div className="text-xs text-purple-300">Streak</div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="p-6 space-y-3">
        <button
          onClick={handlePlayAgain}
          className={`w-full py-4 rounded-xl font-bold text-lg bg-gradient-to-r ${performance.color} active:scale-95 transition-transform`}
        >
          🔄 Играть ещё
        </button>
        
        <button
          onClick={handleCreateOwn}
          className="w-full py-4 rounded-xl font-bold text-lg bg-white/20 hover:bg-white/30 active:scale-95 transition-all"
        >
          🎲 Создать свою тему
        </button>
        
        <button
          onClick={handleShare}
          className="w-full py-3 rounded-xl font-medium text-purple-300 hover:text-white active:scale-95 transition-all"
        >
          📤 Поделиться результатом
        </button>
      </div>
    </div>
  );
}